import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import me3Logo from '../ASUPhotos/logos/me3_logo_black_NEW.png';
import { saveRegistrationSource } from '../store/actions';
import { handleFederatedSignIn } from './auth/authUtil';
import CampusBackground from './CampusBackground';
import IntroImage from './IntroImage';
import PoweredBy from './utility/PoweredBy';
import LandingIntroButtons from './LandingIntroButtons';
import { landingPage_GTM } from '../gtm/datalayers/landingDataLayers.json';
import { login_GTM, playNow_GTM } from '../gtm/datalayers/utilDataLayers.json';
import { fireGTM } from '../gtm/gtmUtil';
import RogersFoundationLogoSection from './utility/RogersFoundationLogoSection';

const landingButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant.secondary,
    color: 'black',

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.secondary}`,
      color: props.tenant.secondary,
      borderStyle: 'solid',
    },
  }),
};

export class Landing extends Component {
  constructor(props) {
    super(props);
    this.showLogin = this.showLogin.bind(this);
    this.startPlaying = this.startPlaying.bind(this);
    this.showIntro = this.showIntro.bind(this);
    this.showVideo = this.showVideo.bind(this);
  }

  showLogin = () => {
    fireGTM(login_GTM, 'login', 'me3');
    this.props.history.push('login');
  };

  loginWithBaobab = () => {
    this.props.handleFederatedSignIn(this.props.tenant.name);
  };

  showIntro = () => {
    fireGTM(landingPage_GTM.readIntro, 'read introduction', 'me3');
    this.props.history.push('introduction');
  };

  showVideo = () => {
    fireGTM(landingPage_GTM.showIntro, 'introduction video', 'me3');
    this.props.history.push('introduction?video=true');
  };

  startPlaying() {
    fireGTM(playNow_GTM, 'play now', 'me3');
    this.props.history.push('onboarding/education');
  }

  primaryBorder = {
    borderTop: `5px solid ${this.props.tenant.primary}`,
  };

  visitLink() {
    const me3Link = 'https://me3.careers';

    window.open(me3Link, '_blank');
  }

  leftContent = (t) => (
    <div className="login-or-play-container">
      <div
        role="link"
        className="me3-link"
        onClick={this.visitLink}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) this.visitLink();
        }}
        tabIndex="0"
      >
        <img className="me3-logo" src={me3Logo} alt="me3" />
      </div>
      {this.props.tenant.name === 'Baobab' ? (
        <div className="show-login-container show-login-container__baobab">
          <p className="label-text prompt-text">{t('Welcome!')}</p>
          <button
            className={[
              'me3-button',
              'button--primary',
              'has-text-black',
              this.props.classes.color,
            ].join(' ')}
            data-cy="login"
            onClick={this.loginWithBaobab}
            type="submit"
            style={this.secondaryBackground}
          >
            {t('Login with {{loginProvider}}', { loginProvider: 'Baobab' })}
          </button>
        </div>
      ) : (
        <>
          <div className="play-container">
            <p className="label-text prompt-text">{t('New User')}</p>
            <button
              className={[
                'me3-button',
                'button--primary',
                'has-text-black',
                this.props.classes.color,
              ].join(' ')}
              data-cy="landing-play"
              onClick={this.startPlaying}
              type="submit"
            >
              {t('Get started')}
            </button>
          </div>
          <div className="show-login-container">
            <p className="label-text prompt-text">{t('Returning user')}</p>
            <button
              className={[
                'me3-button',
                'button--primary',
                'has-text-black',
                this.props.classes.color,
              ].join(' ')}
              data-cy="login"
              onClick={this.showLogin}
              type="submit"
              style={this.secondaryBackground}
            >
              {t('Login')}
            </button>
          </div>
        </>
      )}
      <LandingIntroButtons
        color={this.props.tenant.primary}
        goToIntro={this.showIntro}
        showVideo={this.showVideo}
      />
    </div>
  );

  render() {
    return (
      <Translation>
        {(t) => (
          <CampusBackground
            secondaryColor={this.props.tenant.secondary}
            showLangDropdown
          >
            <div className="main-left" style={this.primaryBorder}>
              {this.leftContent(t)}
              {!!this.props.tenant.features &&
              this.props.tenant.features.includes('rogers_foundation') ? (
                <RogersFoundationLogoSection tenant={this.props.tenant} />
              ) : (
                <PoweredBy tenant={this.props.tenant} />
              )}
            </div>
            <IntroImage showTutorial />
          </CampusBackground>
        )}
      </Translation>
    );
  }
}

const LandingWithRouter = withRouter(Landing);
const connectedLanding = connect((state) => state, {
  saveRegistrationSource,
  handleFederatedSignIn,
})(LandingWithRouter);

export default withStyles(landingButtonStyles)(connectedLanding);
